module.exports = __webpack_public_path__ + "static/media/header-bg.69d4b82e.png";